
namespace RioERP.Reports {
    export class OrderInstallmentReportColumns {
        static columnsKey = 'Reports.OrderInstallmentReport';
    }
}